import React, { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { Lock, Unlock, RefreshCw } from 'lucide-react';
import { getLockouts, clearLockout } from '../api';
import { toast } from '../hooks/use-toast';

const Row = ({ label, sub, onUnlock, testId }) => (
  <div className="flex items-center justify-between bg-white rounded-md p-3 border border-orange-200" data-testid={testId}>
    <div>
      <p className="font-bold text-gray-900">{label}</p>
      <p className="text-xs text-gray-500">{sub}</p>
    </div>
    <Button size="sm" onClick={onUnlock} className="bg-green-600 hover:bg-green-700 text-white" data-testid={`${testId}-unlock`}>
      <Unlock className="w-4 h-4 ml-1" />שחרר נעילה
    </Button>
  </div>
);

export const LockoutsPanel = () => {
  const [data, setData] = useState({ accounts: [], ips: [] });

  const load = () => getLockouts().then(setData).catch(() => setData({ accounts: [], ips: [] }));
  useEffect(() => { load(); }, []);

  const unlock = async (payload, label) => {
    try {
      await clearLockout(payload);
      toast({ title: 'שוחרר', description: `הנעילה של ${label} הוסרה` });
      load();
    } catch (error) {
      toast({ title: 'שגיאה', description: error.response?.data?.detail || 'לא ניתן לשחרר', variant: 'destructive' });
    }
  };

  const empty = data.accounts.length === 0 && data.ips.length === 0;
  return (
    <div className="bg-gradient-to-br from-orange-50 to-amber-50 p-5 rounded-lg border-2 border-orange-200" data-testid="lockouts-panel">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-lg font-bold text-orange-900 flex items-center gap-2"><Lock className="w-5 h-5" />חשבונות נעולים</h3>
        <button type="button" onClick={load} className="p-1.5 rounded-md text-orange-700 hover:bg-orange-100 transition-colors" title="רענן" data-testid="lockouts-refresh">
          <RefreshCw className="w-4 h-4" />
        </button>
      </div>
      {empty ? (
        <p className="text-sm text-gray-600" data-testid="lockouts-empty">אין כרגע חשבונות או כתובות נעולים</p>
      ) : (
        <div className="space-y-2">
          {data.accounts.map((a) => (
            <Row key={a.username} label={`משתמש: ${a.username}`} sub={`${a.failedCount} ניסיונות כושלים · נותרו ${a.minutesLeft} דקות לנעילה`} onUnlock={() => unlock({ username: a.username }, a.username)} testId={`lockout-account-${a.username}`} />
          ))}
          {data.ips.map((r) => (
            <Row key={r.ip} label={`כתובת IP: ${r.ip}`} sub={`${r.failedCount} ניסיונות כושלים · נותרו ${r.minutesLeft} דקות`} onUnlock={() => unlock({ ip: r.ip }, r.ip)} testId={`lockout-ip-${r.ip.replace(/[.:]/g, '-')}`} />
          ))}
        </div>
      )}
    </div>
  );
};
